import { PatientProviderTypeEnum } from "@mgdx/shared/src/models/Patient";
import { MediaDeviceProvider } from "@mgdx/shared/src/providers/MediaDeviceProvider";
import { VConsoleProvider } from "@mgdx/shared/src/providers/VConsoleProvider";
import { isInMccmApp } from "@mgdx/shared/src/utils/isInMccmApp";
import { ToastContainer } from "@mgdx/ui/components/Toast";
import { ConfirmProvider } from "@mgdx/ui/providers/ConfirmProvider";
import { type PropsWithChildren } from "react";

import { AgreementNewTermsApp } from "./apps/AgreementNewTermsApp";
import { TalkMessageListApp } from "./apps/TalkMessageListApp";
import { useCurrentPatientIsMedicineNotebookUsingQuery } from "./hooks/patient/useCurrentPatientIsMedicineNotebookUsingQuery";
import { useCurrentUser } from "./hooks/useCurrentUser";
import { getInAppView } from "./hooks/useIsInAppView";
import { AppStatusProvider } from "./providers/AppStatusProvider";

export const App = ({ children }: PropsWithChildren<EmptyObject>) => {
  const isInApp = getInAppView() || isInMccmApp();

  const currentUser = useCurrentUser();

  useCurrentPatientIsMedicineNotebookUsingQuery({}, { enabled: currentUser.isLoggedInAndValidAccessToken });

  return (
    <AppStatusProvider
      isInApp={isInApp}
      isInLineApp={currentUser.isInLineApp}
      isPharmacyDispensingEnabled={process.env.DISABLE_DISPENSING !== "true"}
      isPharmacyOnlineEnabled={
        process.env.ENABLE_ONLINE_COUNSELING !== "false" &&
        ((currentUser.userInfo?.loginProviderType !== PatientProviderTypeEnum.LineSundrug &&
          currentUser.userInfo?.loginProviderType !== PatientProviderTypeEnum.LineQol &&
          currentUser.userInfo?.loginProviderType !== PatientProviderTypeEnum.LineTanpopo &&
          currentUser.userInfo?.loginProviderType !== PatientProviderTypeEnum.LineNicho) ||
          process.env.ENABLE_ONLINE_COUNSELING === "true")
      }
    >
      <VConsoleProvider>
        <MediaDeviceProvider>
          <ConfirmProvider>
            {children}

            <ToastContainer />
            <TalkMessageListApp />
            <AgreementNewTermsApp />
          </ConfirmProvider>
        </MediaDeviceProvider>
      </VConsoleProvider>
    </AppStatusProvider>
  );
};
